(() => {
  if (customElements.get('strongest-carousel')) return;
  class StrongestCarousel extends HTMLElement {
    connectedCallback() {
      this.track = this.querySelector('[data-track]');
      this.dotsWrap = this.querySelector('[data-dots]');
      if (!this.track) return;
      this.items = [...this.track.children];
      this._raf = 0;
      this._onScroll = () => { cancelAnimationFrame(this._raf); this._raf = requestAnimationFrame(() => this._update()); };
      this._onResize = () => this._build();
      this.track.addEventListener('scroll', this._onScroll, { passive: true });
      window.addEventListener('resize', this._onResize, { passive: true });
      const prev = this.querySelector('[data-prev]');
      const next = this.querySelector('[data-next]');
      if (prev) prev.addEventListener('click', () => this._go(-1));
      if (next) next.addEventListener('click', () => this._go(1));
      this._build();
      const ap = parseInt(this.dataset.autoplay || '0', 10);
      if (ap > 0 && this.items.length > 1) {
        this._apMs = ap;
        this.addEventListener('pointerenter', () => this._stop());
        this.addEventListener('pointerleave', () => this._start());
        this.addEventListener('touchstart', () => this._stop(), { passive: true });
        this.addEventListener('touchend', () => this._start(), { passive: true });
        document.addEventListener('visibilitychange', () => { document.hidden ? this._stop() : this._start(); });
        this._start();
      }
    }
    disconnectedCallback() { this._stop(); window.removeEventListener('resize', this._onResize); }
    _active() { return getComputedStyle(this.track).overflowX !== 'visible'; }
    _current() {
      const tl = this.track.getBoundingClientRect().left;
      let best = 0, bd = Infinity;
      this.items.forEach((it, i) => { const d = Math.abs(it.getBoundingClientRect().left - tl); if (d < bd) { bd = d; best = i; } });
      return best;
    }
    _go(dir) {
      let i = this._current() + dir;
      if (i < 0) i = this.items.length - 1;
      if (i >= this.items.length) i = 0;
      this._scrollToItem(this.items[i]);
    }
    _scrollToItem(it) {
      const left = it.getBoundingClientRect().left - this.track.getBoundingClientRect().left + this.track.scrollLeft;
      this.track.scrollTo({ left: left, behavior: 'smooth' });
    }
    _start() { if (this._apMs && this.items.length > 1) { this._stop(); this._timer = setInterval(() => this._go(1), this._apMs); } }
    _stop() { if (this._timer) { clearInterval(this._timer); this._timer = null; } }
    _build() {
      var ov = this.track.scrollWidth > this.track.clientWidth + 4;
      this.querySelectorAll('[data-prev],[data-next]').forEach(function (b) { b.style.display = ov ? '' : 'none'; });
      if (!this.dotsWrap) return;
      if (!this._active() || this.items.length <= 1 || !ov) { this.dotsWrap.innerHTML = ''; this.dotsWrap.style.display = 'none'; return; }
      this.dotsWrap.style.display = '';
      if (this.dotsWrap.childElementCount !== this.items.length) {
        this.dotsWrap.innerHTML = '';
        this.items.forEach((it, i) => {
          const b = document.createElement('button');
          b.type = 'button';
          b.className = 'stg-dot';
          b.setAttribute('aria-label', 'Ir para o slide ' + (i + 1));
          b.addEventListener('click', () => this._scrollToItem(it));
          this.dotsWrap.appendChild(b);
        });
      }
      this._update();
    }
    _update() {
      if (!this.dotsWrap || this.dotsWrap.style.display === 'none') return;
      const dots = [...this.dotsWrap.children];
      const cur = this._current();
      dots.forEach((d, i) => d.classList.toggle('is-active', i === cur));
    }
  }
  customElements.define('strongest-carousel', StrongestCarousel);

  if (!customElements.get('strongest-tabs')) {
    class StrongestTabs extends HTMLElement {
      connectedCallback() {
        this.tabs = [...this.querySelectorAll('[data-tab]')];
        this.panels = [...this.querySelectorAll('[data-panel]')];
        this.tabs.forEach((t) => t.addEventListener('click', () => this.select(t.dataset.tab)));
      }
      select(idx) {
        this.tabs.forEach((t) => t.setAttribute('aria-selected', t.dataset.tab === idx ? 'true' : 'false'));
        this.panels.forEach((p) => p.classList.toggle('is-active', p.dataset.panel === idx));
        window.dispatchEvent(new Event('resize'));
      }
    }
    customElements.define('strongest-tabs', StrongestTabs);
  }

  function stgReadmore() {
    document.querySelectorAll('[data-rm]').forEach(function (el) {
      var text = el.querySelector('[data-rm-text]'), btn = el.querySelector('[data-rm-btn]');
      if (!text || !btn) return;
      if (!el.dataset.rmReady) {
        el.dataset.rmReady = '1';
        btn.addEventListener('click', function () {
          var ex = text.classList.toggle('is-expanded');
          btn.textContent = ex ? 'Ver menos' : 'Ver mais';
        });
      }
      if (!text.classList.contains('is-expanded')) {
        btn.hidden = !(text.scrollHeight - text.clientHeight > 2);
      }
    });
  }
  if (document.readyState !== 'loading') stgReadmore(); else document.addEventListener('DOMContentLoaded', stgReadmore);
  window.addEventListener('resize', stgReadmore, { passive: true });
})();
